import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const selectFlashMessage = (state: RootState) => state.flashMessage;

export const flashMessageSelector = createSelector(
  selectFlashMessage,
  (flashMessage) => flashMessage,
);
